export default {
  title: 'Dashboard',
  description: 'Get a summary of your workspace.',
  text: {
    videos_published: 'Videos & Guides Published',
    videos_draft: 'Videos & Guides in Draft',
    total_learners: 'Total Learners',
    total_views: 'Total Views',
    video_views: 'Video Views',
    video_views_for_video: 'Video Views for This Video',
    guide_views_for_guide: 'Guide views',
    total_embed_views: 'Total Video Views',
    unique_embed_views: 'Unique Video Views',
    total_guide_views: 'Total Guide View',
    unique_guide_views: 'Unique Guide View',
    learners: 'Learners',
    learners_for_video: 'Learners for This Video',
    learners_for_guide: 'Learners for this guide',
    new_learners: 'New Learners',
    total_hub_new_learners: 'Knowledge Hub - New Learners',
    top_videos: 'Top Videos',
    top_learning_path: 'Top Collections',
    engagement_metrics: 'Engagement Metric',
    engagement_duration: 'Engagement Duration',
    total_engagement_duration: 'Total Engagement Time',
    avg_engagement_duration: 'Average Engagement Time Per User',
    hub_avg_engagement_duration:
      'Knowledge Hub - Average Engagement Time Per User',
    range: 'Last 30 days',
    views: 'views',
    enrollments_copy: 'enrollments',
    completions_copy: 'completions',
    certified_copy: 'certifications',
    no_video_onboard:
      'Your dashboard seems empty! Start creating videos and train your customers!',
    share_video_onboard:
      'Your dashboard seems empty! Start sharing your videos!',
    start_sharing: 'Start sharing your collections!',
    start_sharing_videos: 'Start sharing your videos!',
    start_sharing_courses: 'Seems empty! Start sharing your courses!',
    note: 'Updated every 24 hours',
    video_analytics: 'Content Level Metrics',
    step_analytics: 'Video Block Level Drilled Down Metrics',
    chapter_analytics: 'Chapter Level Drilled Down Metrics',
    enrollments: 'Course Enrollments',
    completions: 'Course Completions',
    certifications: 'Certifications Issued',
    top_enrolled_courses: 'Top Enrolled Courses',
    top_certifications: 'Top Certified Courses',
    top_completed_courses: 'Top Completed Courses',
  },
};
